import { Component, Input, OnInit } from "@angular/core";
import { PlanDTO } from "src/app/data/schema/Billing/Plans/PlanDTO";

@Component({
    selector: "app-plan-description",
    templateUrl: "./plan-description.component.html",
    styleUrls: ["./plan-description.component.scss"]
})
export class PlanDescriptionComponent implements OnInit {
    @Input()
    public plan: PlanDTO;

    constructor() {}

    ngOnInit(): void {}
}
